<template>
    <main id="home-wrapper">
        <div id="homepage">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: app_url, status: false },
                    { title: 'Beranda', url: app_url, status: true }
                ]"
            ></breadcrumb>
            <section
                id="main-home"
                class="section"
                v-if="banner && banner.length > 0"
            >
            <div class="container">
                <div class="list_article">
                    <carousel
                        :per-page="1"
                        :mouse-drag="false"
                        :navigationEnabled="true"
                        :autoplay="true"
                        :loop="false"
                        @page-change="getSlide"
                        navigationNextLabel='<i class="ion-chevron-right"></i>'
                        navigationPrevLabel='<i class="ion-chevron-left"></i>'
                    >
                        <slide v-for="(data, index) in banner" :key="index">
                            <div class="row-grid swiper-slide">
                                <div class="col-grid-30">
                                    <a :href="data.url" @click="gtmBannerClick(data, index)" class="img-promo-section" :style="{ backgroundImage: 'url(' + data.image_medium + ')' }">
                                    </a>
                                </div>
                                <div class="col-grid-70">
                                    <div class="content-promo-section">
                                        <div
                                            class="wrap-label flex flex-center"
                                        >
                                            <span
                                                ><img
                                                    :src="cdn_url+'/assets/community/images/icon_calendar.png'"
                                                    alt="calendar"
                                            /></span>
                                            <p class="tx-grey date-post">
                                                {{ data.date }}
                                            </p>
                                        </div>
                                        <div class="title-promo">
                                            <h2 class="tx-black">
                                                {{ data.title }}
                                            </h2>
                                            <p class="sub_community">
                                                {{
                                                    data.club
                                                        ? data.club.name
                                                        : data.domain
                                                        ? data.domain
                                                        : "N/A"
                                                }}
                                            </p>
                                            <div
                                                v-if="data.url != null || data.url != '-'"
                                                class="btn-share"
                                                :id="'btn-share-'+index"
                                                :ref="'btn-share-'+index"
                                            >
                                                <div class="shares">
                                              <ShareNetwork
                                                  network="facebook"
                                                  @open="gtmTrackerShare(data, 'Article Share', data.title, 'Facebook', 1,
                                                    'https://facebook.com/sharer/sharer.php?u='+ data.url + '&title=' + data.title + '&description=' + data.summary)"
                                                  :url="data.url"
                                                  :title="data.title"
                                                  :description="data.summary"
                                                >
                                                <i class="ion-social-facebook"></i>
                                              </ShareNetwork>
                                              <ShareNetwork
                                                  network="twitter"
                                                  @open="gtmTrackerShare(data, 'Article Share', data.title, 'Twitter', 2,
                                                    'https://twitter.com/intent/tweet?text='+ data.title +'&url='+ data.url)"
                                                  :url="data.url"
                                                  :title="data.title"
                                                  :description="data.summary"
                                                >
                                                <i class="ion-social-twitter"></i>
                                              </ShareNetwork>
                                              <ShareNetwork
                                                  network="whatsapp"
                                                  @open="gtmTrackerShare(data, 'Article Share', data.title, 'Whatsapp', 3,
                                                              'https://api.whatsapp.com/send?text='+ data.title + data.url)"
                                                  :url="data.url"
                                                  :title="data.title"
                                                  :description="data.summary"
                                                >
                                                <i class="ion-social-whatsapp"></i>
                                              </ShareNetwork>
                                                </div>
                                                <a
                                                    @click="
                                                        showShare('btn-share-'+ index)
                                                    "
                                                    class="sharebtn"
                                                    ><span
                                                        ><i
                                                            class="ion-android-share-alt"
                                                        ></i></span
                                                ></a>
                                            </div>
                                        </div>
                                        <div class="isi-promo">
                                            <span v-html="data.description"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </slide>
                    </carousel>
                </div>
            </div>
            </section>

            <section id="home-news" class="section withPad">
                <div class="container">
                    <div class="section_title">
                        <img
                            class="title-img"
                            :src="cdn_url+'/assets/community/images/top6-news-title.png'"
                        />
                    </div>
                </div>
                <div class="container custom-container">
                  <div class="offset-section">
                    <div class="row-news-list">
                      <NewsCard :news="popularNews" section="Top 6 News" shareTitle="Article Share"></NewsCard>
                    </div>
                  </div>
                </div>
            </section>

            <section id="latest-news" class="section withPad">
                <div class="container">
                    <div class="section_title">
                        <h3>Recent Update</h3>
                    </div>
                </div>
                <div class="container custom-container">
                  <div class="offset-section">
                    <div class="row-news-list">
                      <NewsCard :news="recentNews" section="Recent Update"></NewsCard>
                    </div>
                  </div>
                </div>
            </section>

            <section id="upcoming-events" class="section withPad blackBg">
                <div class="container">
                    <div class="section_title">
                        <h3>Upcoming Event</h3>
                    </div>
                </div>
                <div class="inner_section">
                    <div class="container">
                        <div class="list-event">
                            <EventCard :eventData="event"></EventCard>
                        </div>
                        <div class="row-button">
                            <a @click="gtmTrackerBtn('Upcoming Event')" href="/community/event" class="seeMore">See More</a>
                        </div>
                    </div>
                </div>
            </section>

            <section id="community-family" class="section withPad">
                <div class="container">
                    <div class="section_title">
                        <h3>Honda Community Website Family</h3>
                    </div>
                </div>
                <div class="inner_section">
                    <div v-if="loader" class="loading loading-double"></div>
                    <div v-else class="container">
                        <div class="rows">
                            <div class="row-grid">
                                <div class="col-grid-50">
                                    <div class="custom_vselect custom_vselect-large">
                                        <v-select
                                            :options="motorCategories"
                                            label="title"
                                            :placeholder="motorCategoryPlaceholder"
                                            @input="changeMotorCategory($event,'motor_category')"
                                            v-model="motor_category"
                                        >
                                        </v-select>
                                    </div>
                                </div>
                                <div class="col-grid-50">
                                    <div class="custom_vselect custom_vselect-large">
                                        <v-select
                                            :options="provinces"
                                            label="name"
                                            :placeholder="provincePlaceholder"
                                            @input="changeProvince($event)"
                                            v-model="province"
                                        >
                                        </v-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="list-logo">
                                <carousel
                                    :per-page="1"
                                    :mouse-drag="false"
                                    :navigationEnabled="true"
                                    :autoplay="true"
                                    :loop="true"
                                    navigationNextLabel='<i class="ion-chevron-right"></i>'
                                    navigationPrevLabel='<i class="ion-chevron-left"></i>'
                                    v-if="clubs.length > 0"
                                >
                                <slide  v-for="(clubdata,index) in clubs" :key="index">
                                   <div class="row-grid">
                                    <div class="col-grid-20" v-for="(club,index) in clubdata" :key="index">
                                        <div class="item_family">
                                            <a @click="gtmTrackerClub(club)" target="_blank" :href="club.url"><img :src="club.logo" /></a>
                                        </div>
                                    </div>
                                    </div>
                                </slide>
                            </carousel>
                            <div v-else class="messagebox">
                                <h4>Community tidak ditemukan</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div class="popup" v-if="popupProfile">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-container">

                        <div class="modal-header">
                            <a @click="popupProfile = false"><i class="ion-close"></i></a>
                        </div>

                        <div class="modal-body">
                            <p>Silahkan lengkapi profile pribadi anda di halaman profile HCID</p>
                        </div>

                        <div class="modal-footer">
                            <a :href="app_url + '/hcid' " class="btn-lengkapi">
                                Lengkapi Profile
                            </a>
                        </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </main>
</template>

<script>
import BreadCrumb from "../../widget/BreadCrumb";
import NewsCard from "../news/NewsCard";
import EventCard from "../../widget/EventCard";
import { isMobile } from "mobile-device-detect";
import { Carousel, Slide } from "vue-carousel";
import 'vue-select/dist/vue-select.css';
import vSelect from "vue-select";

export default {
    components: {
        Carousel,
        Slide,
        breadcrumb: BreadCrumb,
        NewsCard,
        EventCard,
        "v-select": vSelect,
    },
    data() {
        return {
            cdn_url: cdn_url,
            popupProfile: false,
            currentIndex: 0,
            getFilter: '',
            currentUrl : '',
            base_url:'',
            app_url:'',
            api_url:'',
            show: false,
            mobile: false,
            tlength: 25,
            popularNews: [],
            recentNews: [],
            event: [],
            headlineNews: null,
            banner: null,
            loader:true,
            clubs:[],
            provinces:[],
            province:null,
            provincePlaceholder:'Cari Komunitas di Provinsimu',
            motorCategories:[],
            motor_category:null,
            motorCategoryPlaceholder:'Pilih Kategori Motor',
            endpoint: api_url+'/static/club',
            queryString:{
                category:null,
                province:null,
            }
        };
    },
    created() {
        this.currentUrl = window.location.href;
        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.mobile = isMobile;
        this.getHeadlineNews();
        this.getNews();
        this.getEvent();
        this.getBanner();
        this.getProvince();
        this.getClub(api_url+'/static/club/');
        this.getMotorCategory();
        const user = JSON.parse(localStorage.getItem('user'));
        if (auth && user.hcid == null) {
            this.popupProfile = true;
        }
    },
    methods: {
        // Trasker GTM
        gtmBannerClick(banner, index) {
            var data = {
                'event': 'eventsBannerClick',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action':'Events Banner Click',
                'eventDetail.label': banner.title,
                'creativeName': banner.title,
                'position':index + 1,
                'destinationPageUrl': banner.url
            }
            console.log(data)
            dataLayer.push(data)
        },
        gtmTrackerSlider(index) {
            var slide = this.banner[index];
            var data = {
                'event': 'eventsBannerView',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action':'Events Banner View',
                'eventDetail.label': slide.title,
                'creativeName':slide.title,
                'position': index+1
            }
            console.log(data)
            dataLayer.push(data);
        },
        gtmTrackerShare(data, action, lable, pagePlatform, position, url) {
            var track = {
                'event': 'articleShare',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action': action,
                'eventDetail.label': lable,
                'position': position,
                'pageUrlPlatform': pagePlatform,
                'destinationPageUrl': url,
            };
            dataLayer.push(track)
        },
        gtmTrackerBtn(pageList) {
            var data = {
                'event': 'seeMore',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action': 'See More Detail',
                'eventDetail.label': window.location.href,
                'list': pageList
            }
            console.log(data)
            dataLayer.push(data);
        },
        gtmTrackerSearch() {
            var province = null;
            var motor_category = null;
            if (this.province != null) {
                province = this.province.name;
            }
            if (this.motor_category  != null) {
                motor_category = this.motor_category.title;
            }
            var data = {
                'event': 'websiteSearch',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action': 'Community Website Search',
                'eventDetail.label': this.currentUrl,
                'motorCategory': motor_category,
                'province': province
            }
            dataLayer.push(data);
        },
        gtmTrackerClub(club) {
            var data = {
                'event': 'websiteClick',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action':'Community Website Click',
                'eventDetail.label': club.name,
                // 'eventDetail.label': this.currentUrl,
                'website': club.url,
                'motorCategory': club.category || 'All',
                'province': club.provinsi_id,
                'destinationPageUrl': club.url
            }
            console.log(data)
            dataLayer.push(data);
        },
        // End Traker GTM
        getSlide(index) {
            this.currentIndex = index;
            this.gtmTrackerSlider(this.currentIndex, this.banner[
                this.currentIndex
            ]);
        },
        showShare(element) {
            if(element){
              let classList = this.$refs[element][0].classList;
              if(classList.value.includes("active")){
                classList.remove('active');
              }else{
                classList.add('active');
              }
            }else{
              this.show = !this.show;
            }
        },
        getHeadlineNews() {
          axios
              .get(api_url+"/news-headline")
              .then(res => {
                  if (res.status == 200) {
                      if (res?.data?.status) {
                          this.headlineNews = res?.data?.data?.headlineNews;
                      }
                  }
              })
              .catch(err => {
                  console.log(err);
              });
        },
        getBanner() {
            axios
                .get(api_url+"/banner")
                .then(res => {
                    if (res.status == 200) {
                        if (res?.data?.status) {
                            this.banner = res?.data?.data?.banner;
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        getNews() {
            axios
                .get(api_url+"/news-home")
                .then(res => {
                    if (res.status == 200) {
                        if (res?.data?.status) {
                            this.popularNews.push(
                                ...res?.data?.data?.popularNews
                            );
                            this.recentNews.push(
                                ...res?.data?.data?.recentNews
                            );
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        getEvent() {
            const mobileStatus = this.mobile ? 1 : 0;
            axios
                .get(api_url+`/event/hcid`)
                .then(res => {
                    if (res.status == 200) {
                        if (res?.data?.status) {
                            this.event.push(...res?.data?.data?.event);
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        getProvince() {
                this.loader = true;
                axios.get(api_url+'/static/province')
                    .then(response => {
                        this.provinces = response.data.data.provincy;
                        this.loader = false;
                    }).catch(error => {
                        console.log(error);
                    });
        },
        changeProvince(event){
            if(event){
                this.province = event;
                this.queryString.province = event._id;
                var endpoint = this.buildQuery();
                this.getClub(endpoint);
            }else{
                this.queryString.province = null;
                var endpoint = this.buildQuery();
                this.getClub(endpoint);
            }
        },
        getClub(endpoint) {
                this.loader = true;
                if (this.motor_category || this.province) {
                    this.gtmTrackerSearch();
                }
                axios.get(endpoint)
                    .then(response => {
                        this.clubs = response.data.data.club;
                        this.loader = false;
                    }).catch(error => {
                        console.log(error);
                    });
        },
        getMotorCategory() {
            axios.get(api_url+'/static/motor-category')
                .then(response => {
                    this.motorCategories = response.data.data.category_motor;
                }).catch(error => {
                    console.log(error);
                });
        },
        mapOptions(data) {
        var items = data.map((item) => {
            return {id:item._id, title:item.name};
        });
        var uniqes = [ ...new Set(items) ];
        return uniqes;
        },
        changeMotorCategory(event,label){
            if(event){
                this.motor_category = event;
                this.queryString.category = event.title;
                var endpoint = this.buildQuery();
                this.getClub(endpoint);
            }else{
                this.queryString.category = null;
                var endpoint = this.buildQuery();
                this.getClub(endpoint);
            }
        },
        buildQuery() {
            return this.buildUrl(api_url+'/static/club',this.queryString);
        },
        buildUrl(url, parameters){
            var qs = "";
            for(var key in parameters) {
            var value = parameters[key];
            if (value) {
                qs += encodeURIComponent(key) + "=" + value + "&";
            }
            }
            if (qs.length > 0){
            qs = qs.substring(0, qs.length-1);
            url = url + "?" + qs;
            }
            return url;
        },
    }
};
</script>
<style lang="scss">
@media all and (min-width: 768px) {
#main-home{
}
}
</style>
<style scoped lang="scss">
.custom_vselect {
    color: #000;
}
.item_family{
    padding: 20px 0;
    max-width: 100px;
    margin:0 auto;
}
.custom-container{
  .offset-section{
    padding: unset;
  }
}
.list_article {
    padding:40px 0;
    .col-grid-50 {
        display: flex;
        align-items: center;
    }
}
.img-promo-section {
    display: block;
    border-radius: 0px;
    overflow: hidden;
    width:365px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 350px;
    border-radius: 10px;
    img {
        width: 100%;
    }
}

.content-promo-section {
    padding-right: 120px;
    padding-left: 40px;
}
.wrap-label {
    justify-content: start;
}
.wrap-label span {
    font-size: 12px;
    font-weight: 500;
    display: inline-block;
    margin-right: 10px;
}
.date-news span,
.date-news p {
    display: inline-block;
}
.date-news span {
    font-size: 15px;
    margin-right: 5px;
}
.title-promo {
    margin-bottom: 20px;
    h2 {
        margin-top: 0;
        color: #fff;
        margin-bottom: 0;
    }
    p {
        margin: 0;
        line-height: 24px;
        color: #8e8e8e;
    }
    .sub_community{
        margin-bottom: 20px;
    }
}
.btn-share {
    position: relative;
}
.btn-share {
    margin-left: auto;
}
.btn-share a {
    font-size: 12px;
    padding-top: 3px;
    margin-top: auto;
    border-radius: 100px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    width: 25px;
    height: 25px;
    line-height: auto;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    color: #fff;
    background-color: transparent;
}
.btn-share a:hover {
    background-color: #e61b33;
    color: #fff;
}
.active .shares {
    width: 150px;
    left: 32px;
}
.active .shares {
    width: 108px;
    top: 1px;
}
.active .sharebtn {
    color: #999;
    background-color: #f2f2f2;
}
.shares {
    position: absolute;
    bottom: 0;
    left: 35px;
    height: 35px;
    width: 0;
    overflow: hidden;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    a {
        margin: 0 4px;
    }
}
.offset-section {
    padding-left: 7em;
}
.list-logo .row-grid {
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
}
.popup {
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 300px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
        border-radius: 10px;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-header {
        position: relative;
        display: flex;
        justify-content: flex-end;
    }

    .modal-body {
        margin: 20px 0;
        p {
            color: #000;
            font-size: 16px;
            text-align: center;
        }
    }

    .modal-footer {
        position: relative;
        display: flex;
        justify-content: center;
        margin-top: 30px;
        .btn-lengkapi {
            position: relative;
            background-color: #e61b33;
            color: #fff;
            padding: 10px 15px;
            border-radius: 10px;
            &:hover {
                background-color: #282828;
            }
        }
    }
    .modal-default-button {
        float: right;
    }

    /*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

}
@media all and (max-width: 767px) {
    .col-grid-50{
        margin-bottom: 20px;
    }
    .content-promo-section {
        padding-left: 15px;
        padding-right: 15px;
    }
    .offset-section {
        padding-right: 30px !important;
    }
    .list-logo .col-grid-20{
        width: 50%;
    }
    .img-promo-section {
        width:100%;
        height: 300px;
    }
}
</style>
